import moment from 'moment';
import { formatAmount } from '../../../../../app/common/money';
import { PROMO_TYPE } from '../../../../../app/main/settings/promoCodes/constants';
import config from '../../../../../config';
export var getPromoCodeExpirationDate = function (promoCode) {
    var expirationDateRule = promoCode.rules.find(function (item) { return item.kind === 2; });
    if (!expirationDateRule) {
        return null;
    }
    return moment(expirationDateRule.endDate, config.dateFormatISO).format(config.dateFormat);
};
export var renderPromoCodeValue = function (promoCode, currency) {
    if (promoCode.kind === PROMO_TYPE.percentage) {
        return "".concat(promoCode.value, "%");
    }
    return formatAmount(promoCode.value, currency);
};
export var renderHelperMessage = function (promoCode) {
    if (!promoCode) {
        return '';
    }
    var messageParts = [];
    var firstAppointmentRule = promoCode.rules.find(function (item) { return item.kind === 5; });
    var expirationDateRule = promoCode.rules.find(function (item) { return item.kind === 2; });
    var oneTime = promoCode.rules.find(function (item) { return item.kind === 6; });
    if (firstAppointmentRule) {
        messageParts.push('New clients');
    }
    if (oneTime) {
        messageParts.push('One time');
    }
    if (expirationDateRule) {
        messageParts.push("Exp. ".concat(getPromoCodeExpirationDate(promoCode)));
    }
    return messageParts.join(' • ');
};
